import { dataLayerEventParamsTemplate, pushDataLayer } from './baseDataLayer';

const homeBaseLayer = {
  page: '/pyme/cotizacion/landing',
  page_title: 'Pyme - Cotización - Landing',
};

export const clickActionsEvents = {
  recoverHiringBody: 'Click Retoma tu contratación – Body',
  hireBody: 'Click botón Cotiza ahora – Body',
  hirePlans: 'Click botón Cotiza ahora – Bajo página',
  seePlans: 'Click link Ver detalle de planes – Bajo página',
  seeCoverages: 'Click botón Ver todas las coberturas',
  coveragesDetail: (detail: string) => `Click link Ver detalle – ${detail}`,
  seeBenefits: 'Click link Revisa todos los beneficios',
  seeCircles: 'Click link Ir a Circulo',
  quoteSection: (link: string) => `Click link ${link}`,
  hireFooter: 'Click botón – Ir al Centro de ayuda',
  hireFloatingBox: 'Click botón Cotiza online – Pop-up',
  seeDetailPlan: (detail: string) => `Click link Ver más detalles del plan – ${detail}`,
  btnBannerPromo: (promo: string) => `Click promo banner landing ${promo}`,
  btnRequeriments: 'Click link Ver requisitos –body',

  btnAdditionalCoverage: (coverage: string) =>
    `Click Link – Ver detalles – ${coverage} – Cobertura Adicional`,
  btnPreexistingConditions: `Click Link – aquí - Coberturas en preexistencias`,
  btnPreexistingConditionsModal: `Click Link – revisa las condiciones de la exclusión – Modal Preexistencias no cubiertas`,
  btnHireNow: 'Click Cotizar ahora – Menú',
  comparisonTableBtn: (description: string) => `Click Link – Ver detalles – Plan ${description}`,
  copyEmailBannerFooter: 'Click Link - ¿Necesitas asesoría para cotizar? – Banner Footer',
  copyEmailBlueBanner: 'Click Link - ¿Necesitas asesoría para cotizar? – Banner Azul',
  copyEmailHero: 'Click Link - ¿Necesitas asesoría para cotizar? – Hero',
  contactExecutiveOpen: 'Click botón Contactar ejecutiva – Hero',
  contactExecutiveSendData: 'Click botón Enviar datos – Contactabilidad',
  contactExecutiveClose: 'Click botón Cerrar – Contactabilidad',
};

const homeEvents = {
  hiringFloatClick: {
    ...homeBaseLayer,
    action_type: 'click',
    action: 'Click botón Cotiza online – Pop-up',
  },
};

const contactabilityEvents = {
  formView: {
    ...homeBaseLayer,
    action_type: 'Pageview',
    action: 'Pyme Cotización – Contactabilidad – Formulario',
  },
  successView: {
    ...homeBaseLayer,
    action_type: 'Pageview',
    action: 'Pyme Cotización – Contactabilidad – Envío exitoso',
  },
  errorView: {
    ...homeBaseLayer,
    action_type: 'Pageview',
    action: 'Pyme Cotización – Contactabilidad – Error en envío',
  },
};

const trackViewPageEvent = (attribution = '') =>
  pushDataLayer({
    eventParams: {
      ...dataLayerEventParamsTemplate,
      ...homeBaseLayer,
      action_type: 'Pageview',
      action: 'Paso 0 -  Pyme Cotización - Landing',
      attribution,
    },
    user: { userId: '', userEmail: '' },
  });

const trackClick = ({ action, productType }: { action: string; productType?: string }) =>
  pushDataLayer({
    eventParams: {
      ...dataLayerEventParamsTemplate,
      ...homeBaseLayer,
      action_type: 'click',
      action,
      product_type: productType,
    },
    user: { userId: '', userEmail: '' },
  });

export { trackViewPageEvent, trackClick, homeEvents, contactabilityEvents };
